module.exports = __webpack_public_path__ + "img/sel__interior.6aebcd1d.svg";